<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="User Search"
              icon="fas fa-list"
              *ngIf="showInviteUsersButton"
              buttonLabel="INVITE NEW USER"
              buttonIcon="fas fa-envelope"
              (buttonClick)="goToInviteUsers()">
          </card-section-header>
          <card-section-header
              *ngIf="!showInviteUsersButton"
              title="User Search"
              icon="fas fa-list">
          </card-section-header>
          <!-- Filters -->
          <div class="row">
            <div class="col-md-12">
              <div class="filter-flex-row">
                <ng-container *ngIf="siteOwners.length">
                  <div>
                    <label>Site Owner</label>
                    <p-dropdown class="form-control squareDropdown"
                      [(ngModel)]="selectedSiteOwner"
                      [ngModelOptions]="{standalone: true}"
                      [options]="siteOwners"
                      (ngModelChange)="selectedSiteOwnerChange()"
                      placeholder="Select a site owner..."
                      [style]="{'width':'100%'}"
                      filter="true"
                      tabindex="1"
                      [tabindex]="-1"
                      (keydown.enter)="toggleDropdown($event)"
                      (keydown.space)="toggleDropdown($event)">
                    </p-dropdown>
                  </div>
                </ng-container>
                <div>
                  <label>First Name</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'fname')"></text-filter-box>
                </div>
                <div>
                  <label>Last Name</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'lname')"></text-filter-box>
                </div>
                <div>
                  <label>Phone Number</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'phoneNumber')" onlyNumbers></text-filter-box>
                </div>
                <div>
                  <label>Email</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'email')"></text-filter-box>
                </div>
                <div>
                  <label>Contractor</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'contractor')"></text-filter-box>
                </div>
                <div *ngIf="isFilterLoading" class="small-spinner">
                  <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                </div>
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-end">
              <table-action-bar
                (toggleColumns)="columnOptionsSidebarVisible = true">
              </table-action-bar>
            </div>
          </div>
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <p-table
                  [autoLayout]="true"
                  [value]="users"
                  selectionMode="single"
                  (onRowSelect)="onRowSelect($event)"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [sortOrder]="defaultSortOrder"
                  [lazy]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th [pSortableColumn]="'user.firstName'">
                      <div>First Name<p-sortIcon [field]="'user.firstName'"></p-sortIcon></div>
                    </th>
                    <th [pSortableColumn]="'user.lastName'">
                      <div>Last Name<p-sortIcon [field]="'user.lastName'"></p-sortIcon></div>
                    </th>
                    <th [pSortableColumn]="'user.login'">
                      <div>Username<p-sortIcon [field]="'user.login'"></p-sortIcon></div>
                    </th>
                    <th [pSortableColumn]="'user.phoneNumber'">
                      <div>Phone Number<p-sortIcon [field]="'user.phoneNumber'"></p-sortIcon></div>
                    </th>
                    <th [pSortableColumn]="'user.email'">
                      <div>Email<p-sortIcon [field]="'user.email'"></p-sortIcon></div>
                    </th>
                    <th>User Type</th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Contractor')" [pSortableColumn]="'workerUser.maintenance.name'">Contractor
                      <p-sortIcon [field]="'workerUser.maintenance.name'"></p-sortIcon>
                    </th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Activated')" [pSortableColumn]="'user.activated'">Activated
                      <p-sortIcon [field]="'user.activated'"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                  <ng-container *ngIf="loading; else showRows">
                      <tr>
                        <td [attr.colspan]="20">
                          <skeleton-loading-row></skeleton-loading-row>
                        </td>
                      </tr>
                  </ng-container>
                  <ng-template #showRows>
                    <tr [pSelectableRow]="user">
                      <td>{{ user.firstName }}</td>
                      <td>{{ user.lastName }}</td>
                      <td>{{ user.login }}</td>
                      <td>{{ user.phoneNumber }}</td>
                      <td><a href="mailto:{{ user.email }}">{{ user.email }}</a></td>
                      <td>{{ user.userType }}</td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Contractor')">{{ user.maintenanceName }}</td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Activated')" class="table-cell-centered">
                        <ng-container *ngIf="user.activated; else notActivated">
                          <i class="fas fa-check-circle success"></i>
                        </ng-container>
                        <ng-template #notActivated>
                          <i class="fas fa-times-circle danger"></i>
                          <div *ngIf="!user.workerDeleted">
                            <button type="button" class="btn btn-primary btn-link"
                              [disabled]="user.isSendingInvite || user.inviteSent"
                              (click)="$event.stopPropagation(); resendInvite(user)">
                              <span *ngIf="!user.isSendingInvite && !user.inviteSent">Resend invite</span>
                              <span *ngIf="user.isSendingInvite">
                                <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                  Sending...
                              </span>
                              <span *ngIf="user.inviteSent">Invite sent</span>
                            </button>
                          </div>
                        </ng-template>
                      </td>
                    </tr>
                  </ng-template>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr *ngIf="loading">
                    <td [attr.colspan]="20">
                      <skeleton-loading-row></skeleton-loading-row>
                    </td>
                  </tr>
                  <tr *ngIf="!loading">
                    <td [attr.colspan]="20">
                      {{ siteOwners.length && !selectedSiteOwner ? 'Select a site owner to view users' : 'No users found' }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
